/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { useMergeState } from '../../../irmlib/src/hooks'
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material'
import SkeletonGrid from './SkeletonGrid'
import { YDivider } from '../../../irmlib/src/styles'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import * as routePaths from '../../../navigation/routePaths'

const LocalNewDashboardData = (props) => {
  const { userSelectedDistrict, userSelectedBuilding } = props
  const history = useHistory()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [isDataEmpty, setIsDataEmpty] = useState(false)

  const theme = createTheme({
    typography: {
      h6: {
        color: '#58595B',
        fontSize: '16px',
      },
      body1: {
        color: '#58595B',
        fontSize: '14px',
      },
    },
  })

  const initialState = {
    statCount: {
      reqActive: 0,
      reqCompleted: 0,
      reqCancelled: 0,
      boxUploaded: 0,
      boxPending: 0,
      boxFailed: 0,
      boxInProgress: 0,
      boxCompleted: 0,
      boxWmsPending: 0,
      imgFormatError: 0,
      imgHitlReject: 0,
      imgIdpException: 0,
      pending: 0,
      submitted: 0,
      processed: 0,
      uploaded: 0,
      failed: 0,
      cancelled: 0,
      formatError: 0,
      transHitl: 0,
      transIdp: 0
    },
  }

  const [, setState, getState] = useMergeState(initialState)

  useEffect(() => {
    userSelectedDistrict && getStats(userSelectedDistrict, userSelectedBuilding)
  }, [userSelectedDistrict, userSelectedBuilding])

  const getStats = async (district, building) => {
    setIsLoading(true)
    const getRequestsData = await localGdeTransactions.getRequestsByDistrict(
      district,
      building
    )
    // Transmittal sheet data (Card 4) — kept for easy restore; dashboard hides Transmittal Sheet exceptions card
    // const getBoxTransmittalData = await localGdeTransactions.getBoxTransmittalByDist(district, building)
    // const boxTransmittalDocs = getBoxTransmittalData.docs
    const requestsDocs = getRequestsData.docs
    // if (!requestsDocs.length && !boxTransmittalDocs.length) {
    if (!requestsDocs.length) {
      setIsDataEmpty(true)
    } else {
      setIsDataEmpty(false)
    }
    const copyOfReqStat = {
      reqActive: 0,
      reqCompleted: 0,
      reqCancelled: 0,
      boxUploaded: 0,
      boxPending: 0,
      boxFailed: 0,
      boxInProgress: 0,
      boxCompleted: 0,
      boxWmsPending: 0,
      boxWmsUploaded: 0,
      imgFormatError: 0,
      imgHitlReject: 0,
      imgIdpException: 0,
      pending: 0,
      submitted: 0,
      processed: 0,
      uploaded: 0,
      failed: 0,
      cancelled: 0,
      formatError: 0,
      transHitl: 0,
      transIdp: 0
    }
    requestsDocs.forEach((request) => {
      const requestData = request.data()
      // Counting different request 'status'
      switch (requestData.status) {
        case 'pending':
        case 'In Progress':
          copyOfReqStat.reqActive++
          break
        case 'completed':
          copyOfReqStat.reqCompleted++
          break
        case 'cancelled':
          copyOfReqStat.reqCancelled++
          break
        default:
          break
      }
      // Counting box 'status'
      if (requestData.statusCount) {
        for (const statusType in requestData.statusCount) {
          switch (statusType) {
            case 'InProgress':
              copyOfReqStat.boxInProgress += requestData.statusCount[statusType]
              break
            case 'completed':
              copyOfReqStat.boxCompleted += requestData.statusCount[statusType]
              break
            case 'pending':
              copyOfReqStat.boxPending += requestData.statusCount[statusType]
              break
            case 'uploaded':
              copyOfReqStat.boxUploaded += requestData.statusCount[statusType]
              break
            case 'failed':
              copyOfReqStat.boxFailed += requestData.statusCount[statusType]
              break
            case 'wmsPending':
              copyOfReqStat.boxWmsPending += requestData.statusCount[statusType]
              break
            case 'wmsUploaded':
              copyOfReqStat.boxWmsUploaded += requestData.statusCount[statusType]
              break
            default:
              break
          }
        }
        // Counting image exceptions
        if (requestData.statusCount.imgStatCount) {
          for (const imageStatType in requestData.statusCount.imgStatCount) {
            switch (imageStatType) {
              case 'formatError':
                copyOfReqStat.imgFormatError += requestData.statusCount.imgStatCount[imageStatType]
                break
              case 'hitlReject':
                copyOfReqStat.imgHitlReject += requestData.statusCount.imgStatCount[imageStatType]
                break
              case 'idpFailure':
                copyOfReqStat.imgIdpException += requestData.statusCount.imgStatCount[imageStatType]
                break
              default:
                break
            }
          }
        }
      }
    })
    // Counting transmittals counts (restored with Transmittal Sheet exceptions card)
    // boxTransmittalDocs.forEach((Transmittal) => {
    //   const transmittalData = Transmittal.data()
    //   if (transmittalData.formatError) copyOfReqStat.formatError++
    //   if (transmittalData?.idp?.statusCode === 'IDP-501' || transmittalData?.idp?.statusCode === 'IDP-502' || transmittalData?.idp?.statusCode === 'IDP-599') {
    //     copyOfReqStat.transHitl++
    //   } else if (transmittalData?.idp?.statusCode === 'IDP-401' || transmittalData?.idp?.statusCode === 'IDP-402') {
    //     copyOfReqStat.transIdp++
    //   }
    //   switch (transmittalData.status) {
    //     case 'pending':
    //       copyOfReqStat.pending++
    //       break
    //     case 'published':
    //       copyOfReqStat.submitted++
    //       break
    //     case 'processed':
    //       copyOfReqStat.processed++
    //       break
    //     case 'uploaded':
    //       copyOfReqStat.uploaded++
    //       break
    //     case 'failed':
    //       copyOfReqStat.failed++
    //       break
    //     case 'cancelled':
    //       copyOfReqStat.cancelled++
    //       break
    //     default:
    //       break
    //   }
    // })
    setState({ statCount: copyOfReqStat })
    setIsLoading(false)
  }


  return (
    <Box >
      {isLoading && <SkeletonGrid />}
      {isDataEmpty && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '100px',
            backgroundColor: '#f7f7f7',
            borderRadius: '3px',
            border: '1px solid #e0e0e0',
            boxShadow: 1,
            marginTop: 1,
          }}
        >
          <Typography
            variant='h6'
            color='textSecondary'
            sx={{
              fontSize: '1.2rem',
              color: 'gray',
              fontStyle: 'bold',
              textAlign: 'center',
            }}
          >
            No Data Available
          </Typography>
        </Box>
      )}
      {!isLoading && !isDataEmpty && (
        <>
          <YDivider height='30px' />
          <ThemeProvider theme={theme}></ThemeProvider>
          <Grid container spacing={2}>
            {/* Card 1 (Request Details) */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  {/* <CardContent> */}
                  <Typography
                    variant='h6'
                    gutterBottom
                    sx={{ color: isLoading ? '#D3D3D3' : 'inherit' }}
                  >
                    {t('smartCatalog.requests')}
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      {
                        label: t('smartCatalog.active'),
                        count: getState()?.statCount?.reqActive || 0,
                        route: routePaths.localviewActivity,
                        isActive: true,
                      },
                      {
                        label: t('smartCatalog.completedRequests'),
                        count: getState()?.statCount?.reqCompleted || 0,
                      },
                      {
                        label: t('jobStatusObj.Cancelled'),
                        count: getState()?.statCount?.reqCancelled || 0,
                      },
                    ].map((item, index) => (
                      <React.Fragment key={index}>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          sx={{
                            cursor: item.isActive ? 'pointer' : 'default',
                            '&:hover .text': item.isActive
                              ? { color: '#1b75bc', textDecoration: 'none' }
                              : '',
                          }}
                          onClick={() =>
                            item.isActive
                              ? history.push(
                                  `${routePaths.localviewActivity}?district=${userSelectedDistrict}`,
                                  {
                                    selectedDatas: userSelectedDistrict,
                                    label: item.label,
                                    activeTab: 1,
                                  }
                              )
                              : ''
                          }
                        >
                          <Typography className='text' variant='body1'>
                            {item.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant='contained'
                            disabled={!item.isActive}
                            style={{
                              color: 'white',
                              backgroundColor: item.isActive
                                ? '#1b75bc'
                                : '#58595B',
                              width: '70px',
                              height: '25px',
                              marginLeft: '30px',
                              '&:hover .text': item.isActive
                                ? 'default'
                                : 'unset',
                            }}
                            onClick={() =>
                              item.isActive
                                ? history.push(
                                    `${routePaths.localviewActivity}?district=${userSelectedDistrict}`,
                                    {
                                      selectedDatas: userSelectedDistrict,
                                      label: item.label,
                                      activeTab: 1,
                                    }
                                )
                                : ''
                            }
                          >
                            {item.count}
                          </Button>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Card 2 (Box details) */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant='h6'
                    gutterBottom
                    sx={{ color: isLoading ? '#D3D3D3' : 'inherit' }}
                  >
                    {t('routeTitles.boxDetails')}
                  </Typography>
                  <Grid container spacing={2}>
                    {/* Boxes Pending */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('jobStatusObj.pending')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxPending}
                      </Button>
                    </Grid>
                    {/* Boxes InProgress */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('jobStatusObj.In Progress')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxInProgress}
                      </Button>
                      {/* )} */}
                    </Grid>
                    {/* Completed */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('jobStatusObj.completed')}
                      </Typography>
                      {/* )} */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxCompleted}
                      </Button>
                    </Grid>
                    {/* WMS Boxes Pending */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('smartCatalog.oneilBoxesPending')}
                      </Typography>
                      {/* )} */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxWmsPending}
                      </Button>
                    </Grid>
                    {/* Wms Boxes uploaded */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('smartCatalog.oneilBoxesUploaded')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxWmsUploaded}
                      </Button>
                    </Grid>
                    {/* Boxes uploaded */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('jobStatusObj.uploaded')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxUploaded}
                      </Button>
                    </Grid>
                    {/* Boxes failed */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant='body1'>
                        {t('jobStatusObj.failed')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant='contained'
                        disabled
                        style={{
                          color: 'white',
                          backgroundColor: '#58595B',
                          width: '70px',
                          height: '25px',
                          marginLeft: '30px',
                        }}
                      >
                        {getState()?.statCount?.boxFailed}
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 3 (Image Exception) */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant='h6'
                    gutterBottom
                    sx={{ color: isLoading ? '#D3D3D3' : 'inherit' }}
                  >
                    {t('dashBoard.assetExceptions')}
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      {
                        label: t('jobStatusObj.HITL Reject'),
                        count: getState()?.statCount?.imgHitlReject || 0,
                        route: routePaths.localImageExceptionDetails,
                        isActive: true
                      },
                      {
                        label: t('jobStatusObj.IDP Failure'),
                        count: getState()?.statCount?.imgIdpException || 0,
                        route: routePaths.localImageExceptionDetails,
                        isActive: true
                      },
                      {
                        label: t('tableColumns.format'),
                        count: getState()?.statCount?.imgFormatError || 0,
                        route: routePaths.localImageExceptionDetails,
                        isActive: true
                      },
                    ].map((item, index) => (
                      <React.Fragment key={index}>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          sx={{
                            cursor: item.isActive ? 'pointer' : 'default',
                            '&:hover .text': item.isActive
                              ? { color: '#1b75bc', textDecoration: 'none' }
                              : '',
                          }}
                          onClick={() =>
                            item.isActive
                              ? history.push(
                              `${
                                routePaths.localImageExceptionDetails
                              }/${item.label.replace(/\s+/g, '')}`,
                              {
                                district: userSelectedDistrict,
                                building: userSelectedBuilding,
                                label: item.label,
                                activeTab: 1,
                              }
                              ) 
                              : null
                          }
                        >
                          <Typography
                            className='text'
                            variant='body1'
                            // sx={{ color: 'black', textDecoration: 'none' }}
                          >
                            {item.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant='contained'
                            disabled={!item.isActive}
                            style={{
                              color: 'white',
                              backgroundColor: item.isActive
                                ? '#1b75bc'
                                : '#58595B',
                              width: '70px',
                              height: '25px',
                              marginLeft: '30px',
                              '&:hover .text': item.isActive
                                ? 'default'
                                : 'unset',
                            }}
                            onClick={() =>
                              item.isActive
                                ? history.push(
                                `${
                                  routePaths.localImageExceptionDetails
                                }/${item.label.replace(/\s+/g, '')}`,
                                {
                                  district: userSelectedDistrict,
                                  building: userSelectedBuilding,
                                  label: item.label,
                                  activeTab: 1,
                                }
                                )
                                : null
                            }
                          >
                            {item.count}
                          </Button>
                          {/* )} */}
                        </Grid>
                      </React.Fragment>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 4 (Box Transmittals // commented out for #St1758
            <Grid item xs={12} sm={3.5}>
              <Card
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant='h6'
                    gutterBottom
                    sx={{ color: isLoading ? '#D3D3D3' : 'inherit' }}
                  >
                    {t('dashBoard.transmittalSheetExceptions')}
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      {
                        label: t('jobStatusObj.submit'),
                        count: getState()?.statCount?.submitted || 0,
                      },
                      {
                        label: t('transmittalTypeObj.processed'),
                        count: getState()?.statCount?.processed || 0,
                      },
                      {
                        label: t('transmittalTypeObj.uploaded'),
                        count: getState()?.statCount?.uploaded || 0,
                      },
                      {
                        label: t('transmittalTypeObj.failed'),
                        count: getState()?.statCount?.failed || 0,
                        route: '/BoxTransmittalExceptionDetails',
                        exceptionType: 'failed',
                        isActive: true
                      },
                      {
                        label: t('jobStatusObj.HITL Reject'),
                        count: getState()?.statCount?.transHitl || 0,
                        route: '/BoxTransmittalExceptionDetails',
                        exceptionType: 'hitlReject',
                        isActive: true
                      },
                      {
                        label: t('jobStatusObj.IDP Failure'),
                        count: getState()?.statCount?.transIdp || 0,
                        route: '/BoxTransmittalExceptionDetails',
                        exceptionType: 'idpFailure',
                        isActive: true
                      },
                      {
                        label: t('tableColumns.format'),
                        count: getState()?.statCount?.formatError || 0,
                        route: '/BoxTransmittalExceptionDetails',
                        exceptionType: 'format',
                        isActive: true
                      },
                      {
                        label: t('transmittalTypeObj.cancelled'),
                        count: getState()?.statCount?.cancelled || 0,
                      },
                    ].map((item, index) => (
                      <React.Fragment key={index}>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          sx={{
                            cursor: item.isActive ? 'pointer' : 'default',
                            '&:hover .text': item.isActive
                              ? { color: '#1b75bc', textDecoration: 'none' }
                              : '',
                          }}
                          onClick={() =>
                            item.isActive
                              ? history.push(
                              `${
                                routePaths.localboxTransmittalExceptionDetails
                              }/${item.label.replace(/\s+/g, '')}`,
                              {
                                // selectedData: userSelectedDistrict,
                                label: item.label,
                                exceptionType: item.exceptionType,
                                district: userSelectedDistrict,
                                building: userSelectedBuilding,
                                // activeTab: 1,
                              }
                              )
                              : null
                          }
                        >
                          <Typography className='text' variant='body1'>
                            {item.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant='contained'
                            disabled={!item.isActive}
                            style={{
                              color: 'white',
                              backgroundColor: item.isActive
                                ? '#1b75bc'
                                : '#58595B',
                              width: '70px',
                              height: '25px',
                              marginLeft: '30px',
                              '&:hover .text': item.isActive
                                ? 'default'
                                : 'unset',
                            }}
                            onClick={() =>
                              item.isActive
                                ? history.push(
                                `${
                                  routePaths.localboxTransmittalExceptionDetails
                                }/${item.label.replace(/\s+/g, '')}`,
                                {
                                  // selectedData: userSelectedDistrict,
                                  label: item.label,
                                  exceptionType: item.exceptionType,
                                  district: userSelectedDistrict,
                                  building: userSelectedBuilding,
                                  // activeTab: 1,
                                }
                                )
                                : null
                            }
                          >
                            {item.count}
                          </Button>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            */}
          </Grid>
        </>
      )}
    </Box>
  )
}

export default LocalNewDashboardData
